import creditCardType from "credit-card-type";
import { POST_LABEL } from "./constants.js";
import { PAYMENT_GATEWAY_FATZEBRA } from "./paymentGateway.js";

const EMPTY_RENEW_FORM_POST = {
  [POST_LABEL.NAME_ON_CARD]: "",
  [POST_LABEL.CARD_TYPE]: "",
  [POST_LABEL.CARD_NUMBER]: "",
  [POST_LABEL.EXPIRY_MONTH]: "",
  [POST_LABEL.EXPIRY_YEAR]: "",
  [POST_LABEL.CCV]: "",
};

export const buildRenewFormPostSnapshot = (formInputs) => {
  const formPost = { ...EMPTY_RENEW_FORM_POST };

  formInputs.forEach((input) => {
    switch (input.uniqueId) {
      case "expiry-date": {
        const dateRes = String(input.value ?? "").split("/");
        formPost.expiry_month = dateRes[0] ?? "";
        formPost.expiry_year = dateRes[1] ? `20${dateRes[1]}` : "";
        break;
      }
      case "card-number": {
        const sanitizedCardNumber = String(input.value ?? "").split(/\s/).join("");
        formPost.card_number = sanitizedCardNumber;
        const cards = creditCardType(sanitizedCardNumber);
        formPost.card_type = cards.length > 0 ? cards[0].type : "";
        break;
      }
      case "card-name":
        formPost.name_on_card = input.value;
        break;
      case "cvv":
        formPost.ccv = input.value;
        break;
      default:
        break;
    }
  });

  return formPost;
};

export const buildRenewPayload = ({
  monthlyDonationDetails,
  formPost,
  csrfToken,
  stickyHoney,
  paymentGateway = PAYMENT_GATEWAY_FATZEBRA,
}) => {
  const payload = {
    outbound_token: monthlyDonationDetails.outbound_token,
    outbound_id: monthlyDonationDetails.outbound_id,
    payment_schedule_guid: monthlyDonationDetails.payment_schedule_guid,
    [POST_LABEL.CSRF_TOKEN]: csrfToken,
    [POST_LABEL.STICKY_HONEY]: stickyHoney,
    [POST_LABEL.PAYMENT_GATEWAY]: paymentGateway,
    [POST_LABEL.NAME_ON_CARD]: formPost.name_on_card,
    [POST_LABEL.CARD_TYPE]: formPost.card_type,
    [POST_LABEL.EXPIRY_MONTH]: formPost.expiry_month,
    [POST_LABEL.EXPIRY_YEAR]: formPost.expiry_year,
    [POST_LABEL.CARD_TOKEN]: formPost.card_token,
    [POST_LABEL.CARD_LAST4]: formPost.card_last4,
  };

  return payload;
};
